// utils/exportToExcel.js
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const PropertyExport = (property, filename = 'property_export.xlsx') => {
  const selectedAmenities = property.amenities
    .filter((item) => item.selected)
    .map((item) => item.name?.en || '')
    .join(', ');

  const formatBeds = (beds) => {
    return beds.map((bed) => `${bed.type} x ${bed.count}`).join(', ');
  };

  const exportData =
  //  [
    {
      Name: property?.name,
      Address: `${property?.address ?? ''} ${property?.streetNumber ?? ''}, ${property?.city ?? ''}, ${
        property?.province ?? ''
      }, ${property?.postalCode ?? ''}`,
      Size: property?.size,
      PetPolicy: property?.petPolicy,
      Floor: property?.floor,
      HasElevator: property?.hasElevator ? 'Yes' : 'No',
      MaxGuests: property?.maxGuests,
      ManualMaxGuests: property?.manualMaxGuests,
      coordinates: property?.coordinates,
      propertyNotes: property?.propertyNotes,
      Amenities: selectedAmenities,
      Beds: formatBeds(property?.beds),
      agoda: property?.listings?.agoda,
      airbnb: property?.listings?.airbnb,
      booking: property?.listings?.booking,
      other: property?.listings?.other,
      ape: property?.cadastralInfo?.ape,
      cadastralIncome: property?.cadastralInfo?.cadastralIncome,
      cadastralSection: property?.cadastralInfo?.cadastralSection,
      category: property?.cadastralInfo?.category,
      communeCode: property?.cadastralInfo?.communeCode,
      energyClass: property?.cadastralInfo?.energyClass,
      particle: property?.cadastralInfo?.particle,
      sheet: property?.cadastralInfo?.sheet,
      subordinate: property?.cadastralInfo?.subordinate,
      PoliceUserName: property?.policeUserName,
      PolicePassword: property?.policePassword,
      policeApiKey: property?.policeApiKey,
      tourismTaxLoginEmail: property?.tourismTaxLoginEmail,
      tourismTaxLoginPassword: property?.tourismTaxLoginPassword,
      tourismTaxLoginUrl: property?.tourismTaxLoginUrl,
      cin: property?.cin,
      cis: property?.cis,
    }
  // ];

  const exportObjects = Object.entries(exportData).map(([key, value]) => ({
    Field: key,
    Value: value ?? '',
  }));

  // const worksheet = XLSX.utils.json_to_sheet(exportData);
  const worksheet = XLSX.utils.json_to_sheet(exportObjects);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Property');

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  const file = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  saveAs(file, filename);
};
